import {
	differenceInCalendarDays,
	format,
	parseISO,
	startOfMonth,
} from 'date-fns'

import { DateFormat } from '@/shared/tools/dates'

const DEFAULT_FORECAST_WEEKS = 8

export const getMonthToDatePeriod = (now: Date = new Date()) => ({
	start_date: format(startOfMonth(now), DateFormat.system),
	end_date: format(now, DateFormat.system),
})

// `PP` is a localized token: month names and field order follow the active
// date-fns locale (set from the i18n language at init).
export const formatDate = (iso: string) => format(parseISO(iso), 'PP')

export const formatPeriod = (starts: string, ends: string) =>
	`${formatDate(starts)} – ${formatDate(ends)}`

export const getForecastWeeks = (
	period?: { starts_on: string; ends_on: string } | null
) =>
	period
		? Math.max(
				1,
				Math.round(
					(differenceInCalendarDays(
						parseISO(period.ends_on),
						parseISO(period.starts_on)
					) +
						1) /
						7
				)
			)
		: DEFAULT_FORECAST_WEEKS
